// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LpzxK","index":"styles_index__3y421"};